import * as userAction from "../actions/userActions";
import * as meActions from "../actions/meActions";
import { post, get } from "./axiosClient";
import * as requestActions from "../actions/requestActions";
import * as settingsActions from "../actions/settingsActions";
import { resolveLanguage } from "../utils/language";

let store;
let roomClient;
let messagingClient;
let intl;

export default class AuthService {
  static init(storeObj, messagingClientObj, roomClientObj, intlObj) {
    store = storeObj;
    roomClient = roomClientObj;
    messagingClient = messagingClientObj;
    intl = intlObj;
  }

  login(username, password, roomId) {
    store.dispatch(userAction.setLoginProgress(true));
    const language = resolveLanguage(store.getState().user.userLanguage);
    post(`/auth/`, { username: username, password: password, lang: language })
      .then((response) => {
        if (response.status === 200) {
          if (response.data.error === "INCORRECT_USERNAME_OR_PASSWORD") {
            store.dispatch(
              requestActions.notify({
                type: "error",
                text: intl.formatMessage({
                  id: "user.wrongUsernameOrPassword",
                  defaultMessage: "Wrong username or password",
                }),
              })
            );
          } else if (
            response.data.error === "FAILED" &&
            response.data.payload === "TOO_MANY_PASSWORD_ATTEMPTS"
          ) {
            store.dispatch(
              requestActions.notify({
                type: "error",
                text: intl.formatMessage({
                  id: "user.tooManyPasswordAttempts",
                  defaultMessage:
                    "Too many password attempts, please wait for a while",
                }),
              })
            );
          } else if (
            response.data.error === "FAILED" &&
            response.data.payload === "USER_DELETED"
          ) {
            store.dispatch(
              requestActions.notify({
                type: "error",
                text: intl.formatMessage({
                  id: "user.userDeleted",
                  defaultMessage: "This user is deleted.",
                }),
              })
            );
          } else {
            if (!roomId)
              store.dispatch(meActions.setUIStep("MANAGEMENT_SCREEN"));
            localStorage.removeItem("token");
            localStorage.setItem("token", response.data.payload.token);
            localStorage.setItem("user", response.data.payload.user);
            messagingClient.connect(response.data.payload.user.presenceStatus);
            roomClient.setPeerId(response.data.payload.user.id);
            store.dispatch(userAction.setUser(response.data.payload.user));
            store.dispatch(
              settingsActions.setDisplayName(
                response.data.payload.user.firstName +
                  " " +
                  response.data.payload.user.lastName
              )
            );
            store.dispatch(
              meActions.addRole(response.data.payload.user.meetingRole)
            );
            store.dispatch(meActions.loggedIn(true));
            store.dispatch(
              requestActions.notify({
                text: intl.formatMessage({
                  id: "room.loggedIn",
                  defaultMessage: "You are logged in",
                }),
              })
            );
          }
        }
        store.dispatch(userAction.setLoginProgress(false));
      })
      .catch((r) => {
        store.dispatch(meActions.loggedIn(true));
        store.dispatch(userAction.setLoginProgress(false));
      });
  }

  checkAuth(redirectToRoom) {
    store.dispatch(userAction.setLoginProgress(true));
    get(`/auth/check`)
      .then((response) => {
        if (response.status === 200) {
          if (!redirectToRoom) {
            store.dispatch(meActions.setUIStep("MANAGEMENT_SCREEN"));
          }
          roomClient.setPeerId(response.data.payload.id);
          store.dispatch(meActions.loggedIn(true));
          localStorage.setItem("user", response.data.payload);
          store.dispatch(userAction.setUser(response.data.payload));
          store.dispatch(meActions.addRole(response.data.payload.meetingRole));
          messagingClient.connect(response.data.payload.presenceStatus);
          store.dispatch(
            settingsActions.setDisplayName(
              response.data.payload.firstName +
                " " +
                response.data.payload.lastName
            )
          );
        } else {
          store.dispatch(meActions.loggedIn(false));
          if (!redirectToRoom)
            store.dispatch(
              meActions.setUIStep("AUTHENTICATED_ENTRANCE_SCREEN")
            );
        }
        store.dispatch(userAction.setLoginProgress(false));
      })
      .catch((r) => {
        store.dispatch(meActions.loggedIn(false));
        store.dispatch(userAction.setLoginProgress(false));
      });
  }
}
